<div class="card panel-flat-color primary-panel flex-panel">
    <div class="panel-flat-header ws-flex-container-horizontal">
        <h3 class="ws-flex-auto ws-truncate">
            Assessors
            @if (canEdit) {
                <ag-grid-row-count [gridApi]="gridApi"
                                   [gridOptions]="gridOptions"
                                   [cssClass]="null">
                </ag-grid-row-count>
            }
        </h3>
        <div class="ws-flex-none header-button-container">
            @if (editMode && canEdit) {
                <button
                    title="Add"
                    type="button"
                    class="ace-btn btn-text has-icon btn-primary"
                    (click)="addNewAssessor()">
                    <i class="fa fa-plus-circle fa-align"></i>
                </button>
            }
            @if (!editMode && canEdit) {
                <button
                    title="Edit"
                    type="button"
                    class="ace-btn btn-text has-icon btn-primary"
                    [disabled]="!canEnterEditMode"
                    (click)="edit()">
                    <i class="fa fa-pencil fa-align"></i>
                </button>
            }
            @if (editMode && canEdit) {
                <button
                    title="Close"
                    type="button"
                    class="ace-btn btn-text has-icon btn-primary"
                    (click)="cancel()">
                    <i class="fa fa-times fa-align"></i>
                </button>
            }
            @if (editMode && canEdit && hasSelectedRows) {
                <button
                    title="Bulk Remove Assessors"
                    type="button"
                    class="ace-btn btn-text has-icon btn-primary"
                    (click)="bulkRemove()">
                    <i class="fa fa-trash fa-align"></i>
                </button>
            }
            @if (canEdit) {
                <ag-grid-filter-toggle [gridApi]="gridApi"></ag-grid-filter-toggle>
            }
            @if (!isExpanded) {
                <button type="button"
                        class="ace-btn btn-text has-icon btn-secondary"
                        (click)="expandComponent()">
                    <i class="fa fa-arrows-alt" title="Expand"></i>
                </button>
            }
            @if (isExpanded) {
                <button type="button"
                        class="ace-btn btn-text has-icon btn-secondary"
                        (click)="collapseComponent()">
                    <i class="fa fa-compress" title="Collapse"></i>
                </button>
            }
        </div>
    </div>
    <div class="panel-flat-body ws-flex-container-vertical">
        <ws-ag-grid-angular [hidden]="!canEdit"
                            [gridOptions]="gridOptions"
                            (gridReady)="onAgGridReady($event)">
        </ws-ag-grid-angular>
        @if (!canEdit) {
            <div
                class="ws-stretch ws-flex-container-horizontal ws-flex-align-items-center ws-flex-justify-content-center">
                <h4>Using All Assessors</h4>
            </div>
        }
    </div>
</div>

